import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function Cancel() {
  const { t } = useTranslation()
  return (
    <div className="result-page">
      <div className="result-title">{t('checkout.cancelled')}</div>
      <Link to="/chat">{t('checkout.backToChat')}</Link>
    </div>
  )
}
